// extracted by mini-css-extract-plugin
module.exports = {"title":"privacy-policy-module__title___dopBI","content":"privacy-policy-module__content___YFPwl"};